/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Modal } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";
import FontAwesome from 'react-fontawesome';

import './RoomList.css';

import Loading from './Loading';
import QuickEscapeAdder from './QuickEscapeAdder';
import ReviewItem from './ReviewItem';
import OzPills from './OzPills';

import {
  listRooms,
  listReviews,
} from '../../actions';


class ReviewsList extends Component {
  state = {};

  componentDidMount() {
    this.props.listReviews({ room: this.props.room.id, limit: 3 }, { local: true })
      .then(resp => {
        console.log('list reviews resp:', resp);
        if (resp.error) return;
        this.setState({ reviews: resp.items })
      });
  }

  render() {
    let reviews = this.state.reviews || [];
    if (reviews.length == 0) return null;
    let nodes = reviews.map(review => <ReviewItem noButton review={review} />);
    return (
      <div className="ReviewsList">
        <div className="header">Reviews</div>
        {nodes}
      </div>
    );
  }
}


class RoomList extends Component {
  state = {
    ordering: 'rating',
    expand: {},
  };

  componentDidMount() {
    this.setState({ loading: true });
    let params = this.props.params || { limit: 10 };
    this.props.listRooms(params, { local: true, silent: true })
      .then(resp => {
        console.log('RoomList resp:', resp);
        this.setState({
          rooms: resp,
          loading: false,
        })
      });
  }

  expand(roomId) {
    let expand = Object.assign({}, this.state.expand);
    expand[roomId] = true;
    this.setState({ expand });
  }

  renderRooms() {
    let rooms = this.state.rooms;
    if (!rooms) return;

    let sortFn;
    if (this.state.ordering == 'rating') {
      sortFn = (a, b) => {
        let ap = a.percent || 0;
        let bp = b.percent || 0;
        return bp - ap;
      };
    } else {
      sortFn = (a, b) => {
        let ak = a.name;
        let bk = b.name;

        if (ak.indexOf('Communing') != -1) ak = 'm' + ak;
        if (bk.indexOf('Communing') != -1) bk = 'm' + bk;
        return ak.localeCompare(bk);
      };
    }

    let nodes = rooms.items
      .sort(sortFn)
      .map(room => {
        let description = room.description;
        let expandNode;
        if (!this.state.expand[room.id] && description.length > 200) {
          description = description.substr(0, 150) + '...';
          expandNode = (
            <span className="show-more" onClick={() => this.expand(room.id)}>show more</span>
          );
        }

        return (
          <div className="room" key={room.id}>
            <div className={cx('img-wrapper', { 'no-image': !room.defaultImg })}>
              <div className="img" style={{ backgroundImage: 'url(' + room.defaultImg + ')' }}>
              </div>
            </div>
            <div className="info">
              <div className="header">
                <div className="name-company">
                  <div className="name">{room.name}</div>
                  <div className="company">
                    <div>By <a href={room.location.companyFk.url}>{room.location.company}</a></div>
                    {room.priceHuman && <div className="price">{room.priceHuman}</div>}
                  </div>
                </div>
                <div className="cta">
                  <div className="more-info">
                    <a href={room.url}><Button bsStyle="primary" bsSize="lg">Visit Room Site</Button></a>
                  </div>
                </div>
              </div>

              <div className="description">{description}{expandNode}</div>
              <div className="add-escape">
                <p>
                  <b>Did this room?</b> Track your escape and add a review!
                </p>
                <QuickEscapeAdder
                  autoReview
                  room={room}
                  user={this.props.user}
                />
              </div>

              <div>
                <ReviewsList
                  room={room}
                  listReviews={this.props.listReviews}
                />
              </div>
            </div>
          </div>
        );
      });

    return (
      <div className="rooms">
        <div className="room-filters">
          <div className="filter">
            <div className="name">
              Sort by
            </div>
            <OzPills value={this.state.ordering}>
              <div key="rating" onClick={() => this.setState({ ordering: 'rating' })}>Rating</div>
              <div key="alpha" onClick={() => this.setState({ ordering: 'alpha' })}>A-Z</div>
            </OzPills>
          </div>
        </div>
        {nodes}
      </div>
    );
  }

  render() {
    return (
      <div className="RoomList">
        {this.state.loading && this.renderRooms()}
        {!this.state.loading && this.renderRooms()}
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    listRooms,
    listReviews,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RoomList);



/** WEBPACK FOOTER **
 ** ./src/components/partials/RoomList.js
 **/